import { render, staticRenderFns } from "./UserCoupons.vue?vue&type=template&id=0e7acca4&scoped=true&"
import script from "./UserCoupons.vue?vue&type=script&lang=js&"
export * from "./UserCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7acca4",
  null
  
)

export default component.exports